<app-mini-layout-wrapper>
  <div class="mini-layout__title">{{text.title}}</div>
  <div class="mini-layout__text">{{text.additionalText}}</div>
  <div class="g-margin-top-20">
    <app-loader></app-loader>
  </div>
</app-mini-layout-wrapper>
